import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EaiwsOptions } from '../models/options';

@Injectable({
    providedIn: 'root'
})
export class OptionsService {
    optionsChnaged = new Subject<EaiwsOptions>()

}
